@use "../../styles/breakpoint.module.scss" as *;

.root {
    background-color: var(--off-white);
    padding-block: var(--spacer-block-xlarge);
}

.heading {
    font: var(--font-h-80-lg);
    text-align: center;
    margin-bottom: var(--spacer-block-small);

    @media ($below-tablet) {
        font: var(--font-h-80-sm);
    }
}

.anchorNav {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--spacer-40);
    height: 55px;
    border-bottom: 1px solid var(--gray-300);
    margin-bottom: var(--spacer-block-xlarge);
    position: sticky;
    top: 0;
    z-index: 5;
    background-color: var(--white);
}

.anchorLink {
    font: var(--font-button-16-lg);
    letter-spacing: 0.54px;
    text-decoration: none;
    color: var(--black);
    padding-bottom: var(--spacer-4);
    border-bottom: 1px solid transparent;
    transition: border-color 0.2s;

    &:hover {
        border-bottom-color: var(--black);
    }

    @media ($below-tablet) {
        font: var(--font-button-16-sm);
    }
}

.locations {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-block-xlarge);
}

.location {
    scroll-margin-top: var(--spacer-block-large);
}

.locationDetails {
    padding-left: calc((100vw - 78vw) / 2);
    padding-right: var(--labui-container-margin);
    margin-top: var(--spacer-block-small);

    @media ($below-tablet) {
        padding-inline: var(--labui-container-margin);
        text-align: center;
    }
}

.locationName {
    font: var(--font-h-40-lg);
    margin-bottom: var(--spacer-8);

    @media ($below-tablet) {
        font: var(--font-h-40-sm);
    }
}

.locationAddress {
    font: var(--font-text-link-14-lg);
    letter-spacing: 0.42px;
    display: block;
    margin-bottom: var(--spacer-4);

    @media ($below-tablet) {
        font: var(--font-text-link-14-sm);
    }
}

.locationContact {
    font: var(--font-text-link-14-lg);
    letter-spacing: 0.42px;
    color: var(--black);
    text-decoration: underline;
    display: block;
    margin-bottom: var(--spacer-4);

    @media ($below-tablet) {
        font: var(--font-text-link-14-sm);
    }
}

.locationActions {
    display: flex;
    gap: var(--spacer-16);
    margin-top: var(--spacer-24);

    @media ($below-tablet) {
        justify-content: center;
    }
}
